import { createGlobalStyle, css } from 'styled-components';

const Typography = createGlobalStyle`${css`
	#smooth-content {
		will-change: transform;
	}

	body {
		position: relative;
		width: 100%;
		min-height: 100vh;
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeightL);
		background-color: var(--white1000);
		color: var(--black1000);
		overflow-x: hidden;
		overflow-y: ${(props) => (props.popupIsOpen || props.isBurgerMenuOpen ? 'hidden' : '')};

		main {
			position: relative;
			display: flex;
			flex-direction: column;
			min-height: 100vh;
			padding-top: var(--headerFixedHeight);
			overflow: hidden;
			z-index: 1;

			&.no-padding {
				padding-top: 0;
			}
		}

		&.hidden {
			overflow: hidden !important;
			max-height: 100dvh !important;
		}

		/* //! For IOS */
		&.touch-action {
			* {
				touch-action: none;
				-ms-touch-action: none;
			}
		}
	}

	/* //! Font sizes */
	.h1,
	h1 {
		font-size: var(--h1);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h2,
	h2 {
		font-size: var(--h2);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h3,
	h3 {
		font-size: var(--h3);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h4,
	h4 {
		font-size: var(--h4);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h5,
	h5 {
		font-size: var(--h5);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h6,
	h6 {
		font-size: var(--h6);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.h7 {
		font-size: var(--h7);
		line-height: var(--lineHeightM);
		font-weight: inherit;
	}

	.p,
	p {
		font-size: var(--p);
		line-height: var(--lineHeightL);
		font-weight: inherit;

		--p: var(--p1);

		&.p1 {
			--p: var(--p1);
		}

		&.p2 {
			--p: var(--p2);
		}
	}

	.input-size {
		font-size: var(--input);
		line-height: var(--lineHeightL);
		font-weight: inherit;
	}

	.header-open {
		font-size: var(--header_open);
		line-height: var(--lineHeightL);
		font-weight: inherit;
	}
`}`;

export default Typography;
